import PropTypes from 'prop-types';

import { Flex, Spacer, Spinner } from '@zillow/constellation';
import { Button } from '@zillow/constellation-10';

const propTypes = {
  pager: PropTypes.object,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  onLoadMoreClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

const defaultProps = {
  pager: {
    startKey: 0,
    endKey: 0,
    hasMore: false,
  },
  text: 'Load more',
  disabled: false,
  isLoading: false,
};

const InfiniteScroller = ({ pager, text, disabled, onLoadMoreClick, isLoading }) => {
  const { hasMore } = pager;

  const handleLoadMoreClick = () => {
    const { endKey } = pager;
    onLoadMoreClick(endKey);
  };

  return (
    <div>
      {hasMore && (
        <Flex display="flex" justifyContent="center">
          {isLoading ? (
            <Spinner size="md" />
          ) : (
            <Spacer marginY="xs">
              <Button
                tone="brand"
                emphasis="filled"
                onClick={disabled ? null : handleLoadMoreClick}
                disabled={disabled}
              >
                {text}
              </Button>
            </Spacer>
          )}
        </Flex>
      )}
    </div>
  );
};

InfiniteScroller.propTypes = propTypes;
InfiniteScroller.defaultProps = defaultProps;

export default InfiniteScroller;
